<template> 
  <v-layout row wrap>
    <!-- Pour chaque visiteurs de la file d'attente -->
    <v-flex
      class="xs12"
      :class="{ 'md6': pupitreViewStatus == 2, 'md4': pupitreViewStatus == 1 }"
      v-for="(dataVisiteurAttente, i) in datasFileAttente"
      :key="i"
    >
      <wz-visiteur-attente
        :visiteur="dataVisiteurAttente"
        :pupitreData="pupitreData"
        @supVisiteurFile="$emit('supVisiteurFile', $event)"
      ></wz-visiteur-attente>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: ['datasFileAttente', 'pupitreData'],
  computed: {
    ...mapState('_StoreWatcheeBox', ['pupitreViewStatus'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheebox/WzViewAttente.vue